import { CONTENT_CARD, CONTENT_PAGINATION_BUTTON } from "constants/widgetTypes.jsx";
import { cssUtil } from "../../utils/cssUtil.js";
import { getBaseStyles, renderBackground } from "../commonStyles.js";

export async function renderContentWidget(
    context,
    widget,
    parent,
    override = null
) {

    const breakpoint = context.currentBreakpoint;

    // Root element
    const el = context.document.createElement("div");
    el.classList.add("widget", "content_widget");

    const styles = {
        ...getBaseStyles(widget, breakpoint)
    };

    el.setAttribute("style", cssUtil.toStyleString(styles));
    el.setAttribute("data-widgetId", widget.uid);
    el.setAttribute("data-widgetType", widget.type);
    el.setAttribute("data-widgetParent", widget.parent);
    parent.appendChild(el);

    // Background
    renderBackground(context, widget, el);

    // Wrapper
    const wrapper = context.document.createElement("div");
    wrapper.classList.add("content_widget__wrapper");

    let textAlign = "center";

    const props = widget?.properties?.desktop;
    const layout = props?.layoutStyle;

    let paginationType = "load_more";

    if (layout?.type === "grid") {
        paginationType = layout.pagination ?? "load_more";

        if (layout.alignment === "left") textAlign = "left";
        if (layout.alignment === "right") textAlign = "right";
    }

    wrapper.setAttribute(
        "style",
        cssUtil.toStyleString({ "text-align": textAlign })
    );

    el.appendChild(wrapper);

    // Fetch content mappings
    const mappings = getContentMapping(widget, context);
    if (!mappings || !mappings.length) return el;

    // Content Card widget
    const contentCard = getContentCardWidget(context, widget);
    if (!contentCard) return el;
    
    // Render cards
    for (const mapping of mappings) {
        const cardOverride = {
            content: mapping
        };

        const renderer = context.renderers[contentCard.type];
        if (!renderer) continue;

        await renderer(context, contentCard, wrapper, cardOverride);
    }

    // Pagination (Load More)
    if (paginationType === "load_more") {
        const paginationWrapper = context.document.createElement("div");
        paginationWrapper.classList.add("pagination_wrapper");

        paginationWrapper.setAttribute(
            "style",
            cssUtil.toStyleString({ "text-align": textAlign })
        );

        el.appendChild(paginationWrapper);

        const paginationButton = getPaginationButtonWidget(context, widget);
        if (!paginationButton) return el;
        const renderer = context.renderers[paginationButton.type];
        if (!renderer) return el;

        await renderer(context, paginationButton, paginationWrapper);
    }

    return el;
}

function getContentMapping(widget, context) {
    const layoutManager = widget?.content;
    if (!layoutManager) return null;

    const mappings = layoutManager?.mappings?.items;

    return mappings;
}

function getContentCardWidget(context, contentWidget) {
    const children = context.widgets.filter(
        w => w.parent === contentWidget.uid
    );

    return children.find(
        w => w.type === CONTENT_CARD
    );
}

function getPaginationButtonWidget(context, contentWidget) {
    const children = context.widgets.filter(
        w => w.parent === contentWidget.uid
    );

    return children.find(
        w => w.type === CONTENT_PAGINATION_BUTTON
    );
}